import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiX } from 'react-icons/pi';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { usePostAgreementTemplate } from 'services/templates/agreement-template';
import { IContractTemplateForm } from 'services/templates/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { contractTemplateUtil } from 'utils';
import { onErrorShowAllErrorsToast } from 'utils/service/errorHandler';

const CreateAgreementTemplate = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const createAgreementTemplate = usePostAgreementTemplate();
  const isParagraphKind = searchParams.get('kind') === 'paragraph';

  const goBackToContractTemplate = () => navigate('/templates-extended');

  const onCreateAgreementTemplate = async (values: IContractTemplateForm) => {
    if (values.sideMenu?.detail) {
      return await createAgreementTemplate.mutateAsync(
        middleware.template.agreement.formToQuery(
          values.sideMenu?.detail.content
        ),
        {
          onSuccess: id =>
            navigate(
              isParagraphKind
                ? `/templates-extended/agreement/edit/${id}/form?kind=paragraph`
                : `/templates-extended/agreement/${id}/form`
            ),
          onError: error => onErrorShowAllErrorsToast(error),
        }
      );
    }
  };

  return (
    <Form.Contract
      tittle={
        isParagraphKind
          ? t('contract-template.paragraphAgreement.title')
          : t('contract-template.agreement.title')
      }
      customBackItem={
        <Button type='button' onlyIcon onClick={goBackToContractTemplate}>
          <Button.Description description={t('button.cancel')} />

          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <>
          <Button type='submit' variant={BUTTON_VARIANT.submit}>
            <Button.Text text={t(`button.create`)} />
          </Button>
        </>
      }
      initialStatus={contractTemplateUtil.agreement.initialStatus}
      initialValues={
        isParagraphKind
          ? contractTemplateUtil.agreement.initialParagraphValues()
          : contractTemplateUtil.agreement.initialValues()
      }
      onSubmit={onCreateAgreementTemplate}
    />
  );
};

export default CreateAgreementTemplate;
